import React from "react";
import ResearchContent from "./researchContent";
import ResearchObservations from "./img/research-observations.png";
import ResearchUserBehaviour from "./img/research-user-behaviour.png";
import IconFaAngleDL from "../img/IconFaAngleDL";
import IconFaAngleDR from "../img/IconFaAngleDR";

function ResearchSection() {
	return (
		<>
			<section className="content-block" id={ResearchContent.meta}>
				<h4 className="section-title-meta"> {ResearchContent.meta} </h4>
				<h3 className="section-title"> {ResearchContent.title} </h3>
				{ResearchContent.paras.map((p) => {
					return <p>{p}</p>;
				})}
				<figure className="image">
					<img src={ResearchObservations} alt={ResearchContent.img01alt} />
					<figcaption>{ResearchContent.img01caption}</figcaption>
				</figure>
				<figure className="image">
					<img src={ResearchUserBehaviour} alt={ResearchContent.img02alt} />
					<figcaption>{ResearchContent.img02caption}</figcaption>
				</figure>
			</section>
			<blockquote className="quote">
				<IconFaAngleDL />
				<span className="statement">{ResearchContent.quote.statement}</span>
				<span className="personna">{ResearchContent.quote.personna}</span>
				<IconFaAngleDR />
			</blockquote>
		</>
	);
}

export default ResearchSection;
